import { isExagoReportId } from './jobIdentity'

/**
 * Spec 195 — what a SAVED schedule's edit dialog may offer, read off the schedule row.
 *
 * Pure, no React.
 */

/**
 * Can this schedule's runs roll their dates forward? Only a GENERIC schedule's can: the
 * runner re-resolves a date preset only on the generic path (`buildScheduleJob`, cb-api
 * `jobs/runner.js`), whose stored filters are an array the token rides on. Every other
 * kind stores its report's own request, which no preset reaches — so a roll-forward
 * choice offered there is saved, or ignored, and changes nothing.
 *
 * An absent `kind` (an older payload) keeps today's behaviour rather than guessing, the
 * same rule `attachSupported` follows in the edit dialog.
 */
export const rollsForward = (schedule) => schedule?.kind == null || schedule.kind === 'generic'

/**
 * Spec 217 — what a schedule's runs do with its dates, as the Schedules table words it, or
 * null when that cannot be said.
 *
 * A generic schedule's window is its `rollForward` token. An Advanced (Exago) schedule never
 * has one (its stored params are its run route's request, not a filter array), so it read
 * "Fixed date range" even when it was saved with As Of today and every run's end date is the
 * day that run happens. cb-api reads that one bit off the stored request
 * (`asOfRollsWithRun`): true, false, or null when it cannot tell — and then nothing is said,
 * rather than a guess. Every other kind replays its stored request unchanged, so its dates
 * are fixed, as before.
 */
export const EXAGO_ROLLING_WINDOW = 'Ends on the day of each run'
export const scheduleWindowLabel = (schedule) => {
  if (isExagoReportId(schedule?.reportId)) {
    if (schedule.asOfRollsWithRun === true) return EXAGO_ROLLING_WINDOW
    if (schedule.asOfRollsWithRun === false) return 'Fixed date range'
    return null
  }
  return schedule?.rollForward && schedule.rollForward !== 'pinned' ? 'Range rolls forward' : 'Fixed date range'
}

/** The catalog report number to print as "Report #N", or null when the id is none (`exago/<guid>`). */
export const reportNumberOf = (schedule) => {
  const id = schedule?.reportId
  return id != null && /^\d+$/.test(String(id)) ? String(id) : null
}
